import { HttpParams } from '@angular/common/http';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { SubSink } from 'subsink';
import * as moment from 'moment';
import { CALENDAR_LOCALE } from '../../../services/constant';
import { DownloadService } from '../download.service';
import {LangChangeEvent, TranslateService} from '@ngx-translate/core';
import {SelectItem} from "primeng/api";
import {TemplateService} from '../../../services/template.service';
import {ApiService} from '../../../services/api.service';
import * as _ from 'lodash';

@Component({
  selector: 'app-download-list',
  templateUrl: './download-list.component.html',
  styleUrls: ['./download-list.component.scss'],
  providers: [TemplateService]
})
export class DownloadListComponent implements OnInit, OnDestroy {
  startDate: Date = new Date(moment().format('YYYY') + '-01-01');
  endDate: Date = new Date(moment().format('YYYY') + '-12-30');
  minDate: Date;
  maxDate: Date;
  loading = false;
  currentPage = 1;
  itemsPerPage = 40;
  totalItems = 0;
  documentList = [];
  approvedList = [];
  rejectedList = [];
  isLoadingConfirm = false;
  showResults = false;
  successEmailList = [];
  failedEmailList = [];
  documentNumber = '';
  selectedCustomercode: any;
  email = '';
  customerCode: any;
  rdDocumentType: any;
  selectedRdDocumentType: any;
  docTypeList: any = null;
  poNumber = '';
  errorMessage;
  sortBy: string;
  sortMode: string;
  calendarLocale = CALENDAR_LOCALE.TH;

  selectedMonth;
  modal: NgbModalRef;
  isCheckAll = false;

  subs = new SubSink();
  tableCol = [];
  defaultLabel = null;

  constructor(private apiService: ApiService,
              private modalService: NgbModal,
              private downloadService: DownloadService,
              private template: TemplateService,
              private translate: TranslateService) {}

  ngOnInit() {
    this.selectedCustomercode = null;
    this.selectedRdDocumentType = null;
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.getDocumentRequestList();
    });
    this.getDocumentRequestList();
    this.rdDocumentType = this.template.getDropdown();
  }

  getDocumentRequestList() {
    this.defaultLabel = this.translate.instant('COMMON.ALL');
    this.tableCol = [];
    if (this.translate.currentLang === 'en') {
      this.calendarLocale = CALENDAR_LOCALE.EN;
    } else {
      this.calendarLocale = CALENDAR_LOCALE.TH;
    }
    this.loading = true;
    const params = new HttpParams()
      .set('page_size', this.itemsPerPage.toString())
      .set('page', this.currentPage.toString())
      .set('status', 'False')
      .set('email', this.email)
      .set('customer_code', this.selectedCustomercode)
      .set('po_number', this.poNumber)
      .set('rd_doc_type', this.selectedRdDocumentType)
      .set('start_date', this.startDate ? moment(this.startDate).format('YYYY-MM-DD') : '')
      .set('end_date', this.endDate ? moment(this.endDate).format('YYYY-MM-DD') : '')
      .set('document_number', this.documentNumber);
    this.translate.get('COMMON.ALL').subscribe((res: string) => {
      const documentTypeData = this.template.getDropdown();
      // documentTypeData[0] = {label: this.translate.instant('COMMON.ALL'), value: null};
      this.rdDocumentType = documentTypeData;
    this.loadInput();
    this.subs.add(
      this.downloadService.getDocumentRequestList(params).subscribe(
        documents => {
          this.documentList = documents['results'];
          this.totalItems = documents['count'];
          this.loading = false;
        },
        error => {
          console.log('error', error);
        }
      ));
    });

  }

  loadInput() {
    this.customerCode = [{
      label: this.translate.instant('COMMON.ALL'),
      value: null
    }];
      let params = new HttpParams();
    params = params.append('none_pagination', 'true')
    this.apiService.getCustomerList(params).subscribe(
      (result) => {
        _.forEach(result, (obj) => {
          this.customerCode.push({
            label: obj.c_code,
            value: obj.c_code
          });
        });
        this.customerCode = _.uniqBy(this.customerCode, 'label');
      },
      error => {
        console.log('error', error);
    }
    );
  }

  get yearRange() {
    const thisYear = new Date().getFullYear();
    return thisYear - 40 + ':' + thisYear;
  }

  get dateRange() {
    const start = moment(this.startDate).format('DD/MM/YYYY');
    const end = moment(this.endDate).format('DD/MM/YYYY');
    return start + ' - ' + end;
  }

  search() {
    this.currentPage = 1;
    this.getDocumentRequestList();
  }

  clearSearch() {
    this.documentNumber = '';
    this.startDate = new Date(moment().format('YYYY') + '-01-01');
    this.endDate = new Date(moment().format('YYYY') + '-12-30');
    this.email = '';
    this.customerCode = '';
    this.poNumber = '';
    this.getDocumentRequestList();
  }

  setMinDate() {
    this.minDate = this.startDate;
    if (this.endDate < this.minDate) {
      this.endDate = this.minDate;
    }
  }

  setMaxDate() {
    this.maxDate = this.endDate;
    if (this.startDate > this.maxDate) {
      this.startDate = this.maxDate;
    }
  }

  open(content) {
    this.showResults = false;
    this.modal = this.modalService.open(content);
  }

  toggleStatusChange() {
    this.approvedList = this.documentList.filter(obj => obj.status);
    this.rejectedList = this.documentList.filter(obj => obj.status);
  }

  confirm() {
    this.isLoadingConfirm = true;
    this.errorMessage = null;

    this.subs.add(
      this.downloadService.updateDocumentRequest(this.approvedList).subscribe(
        res => {
          this.successEmailList = res.success_email_list;
          this.failedEmailList = res.failed_email_list;
        },
        error => {
          console.log('error', error);
          this.checkErrorMsg(error);
          this.isLoadingConfirm = false;

        },
        () => {
          this.isLoadingConfirm = false;
          this.showResults = true;
          this.approvedList = [];
          this.getDocumentRequestList();
        }
      )
    );
  }

  reject() {
    this.isLoadingConfirm = true;
    this.errorMessage = null;

    this.subs.add(
      this.downloadService.rejectDocumentRequest(this.approvedList).subscribe(
        res => {
          this.successEmailList = res.success_email_list;
          this.failedEmailList = res.failed_email_list;
        },
        error => {
          console.log('error', error);
          this.checkErrorMsg(error);
          this.isLoadingConfirm = false;

        },
        () => {
          this.isLoadingConfirm = false;
          this.showResults = true;
          this.rejectedList = [];
          this.getDocumentRequestList();
        }
      )
    );
  }

  checkErrorMsg(error) {
    // this.errorMsgForShow = this.apiService.getErrorMessage(error);
    const errormsg = (error.error.message[0]);
    if (this.translate.currentLang === 'en') {
      this.errorMessage = errormsg;

    } else {
      this.errorMessage = '';
    }
  }

  checkAll() {
    this.documentList.map(obj => {
      obj['status'] = this.isCheckAll;
    });
    this.toggleStatusChange();
  }

  deleteDownloadRequest(id) {
    this.downloadService.deleteDocumentRequest(id).subscribe(
      () => {
        this.documentList = this.documentList.filter(obj => obj.id !== id);
      },
      error => console.log('error', error)
    );
  }

  optionChanged() {
    this.getDocumentRequestList();
  }

  pageChanged() {
    this.getDocumentRequestList();
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}



// WEBPACK FOOTER //
// /opt/app/src/app/features/download/download-list/download-list.component.ts